import { isMobile } from '@/lib/device'
import i18n from '@/lib/language'
export const distributePieOptions = () => {
  const option = {
    chart: {
      spacing: [40, 0, 40, 0]
    },
    title: {
      floating: true,
      text: i18n.t('message["1374"]'),
      align: 'center',
      x: -200,
      y: 140,
      style: {
        fontSize: '14px',
        color: '#666',
        textAlign: 'center'
      }
    },
    subtitle: {
      text: '',
      floating: true,
      align: 'center',
      // verticalAlign: 'bottom',
      x: -200,
      y: 200,
      style: {
        fontSize: '48px',
        color: '#333',
        textAlign: 'center'
      }
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    colors: ['#5077AA', '#4CA0F2', '#42C27E', '#F6A953', '#F57676', '#BD7CE8'],
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      itemHoverStyle: {
        backgroundColor: '#F3F7FA'
      },
      itemStyle: {
        backgroundColor: '#fff'
      },
      useHTML: true, // 设置允许使用 html
      // 使 legend 自带的 symbol 显示为 none 效果
      symbolWidth: 0.001,
      symbolHeight: 0.001,
      symbolRadius: 0.001,
      labelFormatter () {
        // 格式化 legend 的 label
        // 这里的内容根据需求自行编写
        let dom = `<span><span style='color:${
          this.color
        };font-size:18px; vertical-align: middle; margin-right:4px;text-align:center;display:inline-block;width:18px;line-height:36px;'>&bull;</span><span style='font-size:14px;color:#333333;width:150px;display:inline-block; max-height:36px; line-height:18px; white-space: normal; vertical-align: middle;margin-right: 18px;word-break: break-all; overflow:hidden;'>${
          this.name
        }</span><span style='font-size:14px;color:#666666;width:72px;display:inline-block;'>${
          this.y
        }%</span>&nbsp;&nbsp;&nbsp;<span style='font-size:14px; color:#333333;width:100px;display:inline-block'>${
          this.num
        }</span></span>`
        return dom
      }
    },
    tooltip: {
      // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      shared: true,
      style: {
        zIndex: 9999
      },
      backgroundColor: 'rgba(255,255,255,0.95)',
      followTouchMove: false,
      useHTML: true,
      formatter: function () {
        let data = this.point || {}
        let s = `<h3 class="textOverflow" style="width: 90%; font-weight: bold;">${data.name}</h3><p style="margin-bottom: 4px;">${i18n.t('message["1374"]')}：${data.num}</p>`
        if (data.levelinfo) {
          s += '<ul style="padding-top: 4px; text-align: center; border-top: solid 1px #999;">'
          for (let item of data.levelinfo) {
            s += `<li style="display: flex; justify-content: space-between; padding: 0 4px;"><span>${item.name}</span><span>${item.per}</span><span>${item.num}</span></li>`
          }
          s += '</ul>'
        }

        return '<div style="width: 164px; overflow: hidden; line-height: 24px;">' + s + '</div>'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true
        },
        showInLegend: true,
        size: 268,

        tooltip: {
          backgroundColor: 'rgba(255,255,255,1)'
        },

        point: {
          events: {
            legendItemClick: function (e) {
              return false // 直接 return false 即可禁用图例点击事件
            }
          }
        }
      }
    },
    series: [
      {
        type: 'pie',
        innerSize: '80%',
        colorByPoint: true,
        data: [['', 100]]
      }
    ]
  }
  return option
}
export const mobileDistributePieOptions = () => {
  const option = {
    chart: {
      spacing: [10, 0, 10, 0],
      marginTop: -220,
      height: 510,
      width: 370
    },
    title: {
      floating: true,
      useHTML: true,
      text: '',
      x: 0,
      y: 120
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    colors: ['#5077AA', '#4CA0F2', '#42C27E', '#F6A953', '#F57676', '#BD7CE8'],
    legend: {
      layout: 'vertical',
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
        marginTop: '5px'
      },
      floating: true,
      maxHeight: 280,
      x: 0, // x,y设置图例位置
      y: 0,
      useHTML: true, // 设置允许使用 html
      // 使 legend 自带的 symbol 显示为 none 效果
      symbolWidth: 0.001,
      symbolHeight: 0.001,
      symbolRadius: 0.001,
      labelFormatter () {
        // 格式化 legend 的 label
        // 这里的内容根据需求自行编写
        let dom = `<span style='margin-left:18px; margin-top: 10px; display:inline-block;'><span style='color:${
          this.color
        };font-size:20px;margin-right:4px; vertical-align: middle;text-align:center;display:inline-block;width:18px;'>&bull;</span><span style='font-size:14px;color:#333333;width:150px;display:inline-block;max-height:36px; line-height:18px; white-space: normal; vertical-align: middle;margin-right: 18px;word-break: break-all; overflow:hidden;'>${
          this.name
        }</span><span style='font-size:14px;color:#B3B3B3;width:52px;display:inline-block;'>${
          this.y
        }%</span>&nbsp;&nbsp;&nbsp;<span style='font-size:14px; color:#333333;width:90px;display:inline-block'>${
          this.num
        }</span></span>`
        return dom
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: [
      {
        type: 'pie',
        size: '60%',
        innerSize: '80%',
        data: [['', 100]]
      }
    ]
  }
  return option
}
export const highchartBarOption = () => {
  const option = {
    chart: {
      type: 'area'
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5'],
    xAxis: {
      categories: [''],
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: ''
      }
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    plotOptions: {
      column: {
        borderWidth: 0
      }
    },
    series: [
      {
        name: '',
        data: [0]
      }
    ]
  }
  return option
}

export const highchartLineOption = () => {
  const option = {
    chart: {
      type: 'area'
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: ''
      },
      labels: {
        step: 2
      }
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      area: {
        color: '#5077AA'
      },
      series: {
        label: {
          connectorAllowed: false
        },
        fillOpacity: 0.1
      }
    },
    series: [
      {
        name: '---',
        data: [0]
      }
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }
      ]
    }
  }
  return option
}

export const highchartPieOption = options => {
  const option = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    title: {
      text: options.title
    },
    subtitle: {
      text: options.subtitle
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: options.data
  }
  return option
}
// 词云图
export const highChartWordCloudOption = () => {
  const mobileChart = {
    spacing: [40, 0, 40, 0],
    marginTop: 0,
    marginLeft: 10,
    marginRight: 10,
    // marginBottom: 0,
    height: 510,
    width: 370 }
  const pcChart = {}
  const option = {
    chart: isMobile ? mobileChart : pcChart,
    title: {
      text: ''
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    colors: ['#5077AA', '#4CA0F2', '#42C27E', '#F6A953', '#F57676', '#BD7CE8'],
    legend: {
      layout: 'vertical',
      align: isMobile ? 'center' : 'right',
      verticalAlign: isMobile ? 'bottom' : 'middle',
      useHTML: true, // 设置允许使用 html
      maxHeight: isMobile && 220,
      // padding: 30,
      itemMarginTop: -20,
      itemMarginBottom: 25,
      symbolWidth: 0.001,
      symbolHeight: 0.001,
      symbolRadius: 0.001,
      labelFormatter () {
        // 格式化 legend 的 label
        const { userOptions } = this
        const legends = userOptions.arr
        let colors = ['#5077AA', '#4CA0F2', '#42C27E', '#F6A953', '#F57676', '#BD7CE8']
        let dom = '<div>'
        if (!isMobile) {
          for (let i = 0; i < legends.length; i++) {
            let item = legends[i]
            dom += `<p><span style='margin-left:18px; margin-top: 10px; display:inline-block;'><span style='color:${
              colors[i]
            };font-size:20px;margin-right:4px; vertical-align: middle;text-align:center;display:inline-block;width:18px;'>&bull;</span><span style='font-size:14px;color:#333333;width:150px;overflow: hidden; white-space:pre-wrap;text-overflow:ellipsis;display:inline-block;max-height:36px; line-height:18px; white-space: normal; vertical-align: middle;margin-right: 18px;'>${
              item.name
            }</span><span style='font-size:14px;color:#B3B3B3;width:52px;display:inline-block;'>${
              item.per
            }</span>&nbsp;&nbsp;&nbsp;<span style='font-size:14px; color:#333333;width:90px;display:inline-block'>${
              item.num
            }</span></span></p>`
          }
        } else {
          for (let i = 0; i < legends.length; i++) {
            let item = legends[i]
            dom += `<div><span style='margin-left:60px;'><span style='color:${
              colors[i]
            };font-size:20px;margin-right:4px;text-align:center;display:inline-block;width:18px;'>&bull;</span><span style='font-size:14px;color:#333333;width:192px;display:inline-block;overflow:hidden;white-space:pre-wrap;text-overflow:ellipsis; -webkit-line-clamp:1;-webkit-box-orient: vertical'>${
              item.name
            }</span><span style='font-size:14px;color:#B3B3B3;width:35px;display:inline-block;'>${
              item.per
            }</span>&nbsp;&nbsp;&nbsp;<span style='font-size:14px; color:#333333;width:120px;display:inline-block'>${
              item.num
            }</span></span></div>`
          }
        }
        dom += '</div>'
        return dom
      }
    },
    tooltip: {
      enabled: false
      // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      wordcloud: {
        allowPointSelect: false,
        dataLabels: {
          enabled: false
        },
        showInLegend: true,
        events: {
          // 禁止图例点击隐藏事件
          legendItemClick: () => {
            return false
          }
        }
      }
    },
    series: [
      {
        type: 'wordcloud',
        innerSize: '80%',
        data: [['', 100]],
        arr: [],
        rotation: {
          from: 0,
          to: 0,
          orientations: 2
        },
        spiral: 'archimedean',
        placementStrategy: 'random'
      }
    ]
  }
  return option
}

export const highchartAreaOption = () => {
  const option = {
    chart: {
      type: 'area'
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: ''
      },
      labels: {
        step: 2
      }
    },
    xAxis: {
      // tickmarkPlacement: 'on',
      title: {
        enabled: false
      }
    },
    tooltip: {
      // head + 每个 point + footer 拼接成完整的 table
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    plotOptions: {
      area: {
        color: '#5077AA',
        stacking: 'normal',
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2,
          states: {
            hover: {
              enabled: true
            }
          }
        }
      },
      series: {
        label: {
          connectorAllowed: false
        },
        fillOpacity: 0.6
      }
    },
    series: [
      {
        name: '---',
        data: [0],
        color: '#FF0000'
      },
      {
        name: '---',
        data: [0],
        color: '#5077AA'
      }
    ]
    // responsive: {
    //   rules: [
    //     {
    //       condition: {
    //         maxWidth: 500
    //       },
    //       chartOptions: {
    //         legend: {
    //           layout: 'horizontal',
    //           align: 'center',
    //           verticalAlign: 'bottom'
    //         }
    //       }
    //     }
    //   ]
    // }
  }
  return option
}
export const highchartcolumnOption = () => {
  const option = {
    chart: {
      type: 'column'
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: ''
      },
      labels: {
        step: 2
      }
    },
    xAxis: {
      // tickmarkPlacement: 'on',
      title: {
        enabled: false
      },
      crosshair: true
    },
    tooltip: {
      // head + 每个 point + footer 拼接成完整的 table
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    credits: {
      enabled: false // 不显示LOGO
    },
    plotOptions: {
      column: {
        borderWidth: 0
      }
    },
    series: [
      {
        name: '---',
        data: [0],
        color: '#FF0000'
      },
      {
        name: '---',
        data: [0],
        color: '#5077AA'
      }
    ]
  }
  return option
}
